import {createSlice, Dispatch, PayloadAction} from '@reduxjs/toolkit';
// import {client} from '../App';
// import {GET_USER} from '../helpers/queries';

//import {Impersonification} from '../models/Impersonification';
// import {LoadingErrorType} from '../helpers/enums';
// import {GetCustomerTransformToProfile} from "../helpers/helpers";


const initialState: any = {
    profileData:{},
    error: null,
};


const impersonificationSlice  = createSlice({
    name:"impersonification",
    initialState,
    reducers:{
        receivedSearchData(state, action: PayloadAction<any | null>): void {
            state.profileData = action.payload;
        },
        setLoadingError(state, action: PayloadAction<any | null>): void {
            state.error = action.payload;
        }
    }
});


export const {
    receivedSearchData,
    setLoadingError
} = impersonificationSlice.actions;
  
  
  export default impersonificationSlice.reducer;


  // const data = [
  //   { head: 'codice utenza', text: '1670396' },
  //   { head: 'denominazione', text: 'Corbanelli Francesco' },
  //   { head: 'codice fiscale', text: 'CRBNLC98537163TG' },
  //   { head: 'partita iva', text: '-' },
  //   { head: 'registrazione sportello web', text: 'B2C: Lucianoparola40 - Corbanelli Francesco CRBNLC98537163TG' },
  // ];
  
  export const getSearchProfileData = () => (dispatch: Dispatch) => {
    return function (dispatch: Dispatch) {
      console.log("DISPATCHING")

      //    return client.query({
      //      query: GET_USER,
      //      variables: {},
      //    })
      //      .then(({data}) => {
      //        dispatch(receivedSearchData(data.getBills));
      //      })
      //      .catch((e: any) => {
      //        const errors = e.networkError.result.errors.map((error: any) => error.extensions.code);
      //        if (errors.length > 0) {
      //          dispatch(setLoadingError(LoadingErrorType.CannotGetBills));
      //        }
      //      });
      // }
    }
  }
